

import 'regenerator-runtime/runtime';
//import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
 
import "isomorphic-fetch"
const Api = require('./components/Config');


require("react-hot-loader/patch")



import Root from './config/Root';

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root'),
  );
};


if (module.hot) {

  module.hot.accept(  () => {
    
    render(Root);
  });
  render(Root); 
}
else
{
  render(Root); 
}

if(Api.getBuild()=='STAGE')
{
  document.body.style.backgroundColor='#e9d3ff';
}
if(Api.getBuild()==='DEV')
{
   document.body.style.backgroundColor='#fac898';
}
